import React from 'react';
import { bindActionCreators } from 'redux';
import { chartActions } from '../../store/charts/chartsStore';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { hasPermission } from '../../store/apiWrapper';
import { withLocalize, Translate } from "react-localize-redux";
import { withRouter } from 'react-router';
import AddrIcon from '../../img/icons/Domu';
import BbPopover from '../common/popover';
import ChartWarningsLegend from './chartWarningsLegend';
import classnames from 'classnames';
import FoIcon from '../../img/icons/FyzickaOsoba';
import FpoIcon from '../../img/icons/FyzickaOsobaPodnikatel';
import PoIcon from '../../img/icons/PravnickaOsoba';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { chartExportTypes } from '../../store/charts/exports/initial';

class ChartSubjects extends React.Component {
    render() {
        return (
            <>
                <div id="buttonsSubjectList">
                    {this.renderExportButtonWithPover("Export (xlsx)", () => this.props.exportToXlsx(chartExportTypes.xlsxSl), chartExportTypes.xlsxSl)}
                    {hasPermission(null, "RCexportCSV") && this.renderExportButtonWithPover("Export (csv)", () => this.props.exportToCsv(chartExportTypes.csvSl), chartExportTypes.csvSl)}
                </div>

                <table id="tableSubjectList">
                    <thead>{this.renderSlHeader(this.props.bottomWindow.subjects.data)}</thead>
                    {this.props.bottomWindow.subjects.data && <tbody className={classnames({ 'warn-profi': (this.props.topPanel || {}).isProfi === true })}>{this.renderSlData(this.props.bottomWindow.subjects.data.nodes, this.props.bottomWindow.subjects.data.maxLevel)}</tbody>}
                </table>

                <div id="divWarningShortcuts">
                    <input type="hidden" id="profiVersionSelected" value="false" />

                    <ChartWarningsLegend />

                    <div style={{ padding: '0 5px 5px 0' }}>
                        <strong style={{ paddingLeft: '5px' }}><Translate id="Charts.LegendsToolTip" /></strong>
                    </div>
                    <table style={{ width: 'auto', marginTop: 0 }}>
                        <thead>
                            <tr>
                                <th style={{ minWidth: '75px' }}><Translate id="Charts.Icon" /></th>
                                <th style={{ minWidth: '100px' }}><Translate id="Charts.WarningDescription" /></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td><i className="rc-icon subject-list-icon-rc rc-subject-po" style={{ height: '18px', top: '-3px' }}></i></td><td>PO</td></tr>
                            <tr><td><i className="rc-icon subject-list-icon-rc rc-subject-fop" style={{ height: '18px', top: '-3px' }}></i></td><td>FOP</td></tr>
                            <tr><td><i className="rc-icon subject-list-icon-rc rc-subject-fo" style={{ height: '18px', top: '-3px' }}></i></td><td>FO</td></tr>
                            <tr><td><FontAwesomeIcon icon="map-marker" style={{ height: '18px', paddingLeft: '7px', fontSize: '1.5em', color: '#525251' }} /></td><td>AD</td></tr>
                            <tr><td style={{ lineHeight: '16px', fontSize: '22px' }}>←</td><td><Translate id="Charts.LinkDirectionBackward" /></td></tr>
                            <tr><td style={{ lineHeight: '16px', fontSize: '22px' }}>→</td><td><Translate id="Charts.LinkDirectionForward" /></td></tr>

                            <tr><td><div><span className="link-guarantee link-guarantee-unsure" style={{ float: 'left', marginLeft: '5px' }}></span></div></td><td><Translate id="Charts.LinkGuaranteeUnsure" /></td></tr>
                            <tr><td><div><span className="link-guarantee link-guarantee-lessCertain" style={{ float: 'left', marginLeft: '5px' }}></span></div></td><td><Translate id="Charts.LinkGuaranteeLessCertain" /></td></tr>
                            <tr><td><div><span className="link-guarantee link-guarantee-certain" style={{ float: 'left', marginLeft: '5px' }}></span></div></td><td><Translate id="Charts.LinkGuaranteeCertain" /></td></tr>
                        </tbody>
                    </table>
                </div>
            </>
        );
    }

    renderExportButtonWithPover = (title, onClickFunc, exportType) => {
        const exportUsed = this.props.exports.exportUsed.includes(exportType);
        return (
            <BbPopover
                content={this.props.translate('Common.Button.ExportPdf.Processing')}
                placement="right"
                targetId={`rc-subjects-export-button-${exportType}`}
                toggleOnEvent={exportUsed ? "toggleOnMouse" : "toggleNever"}
                withDelayAfterFirstToggle
            >
                {this.renderExportButton(title, onClickFunc, exportType)}
            </BbPopover>
        );
    }

    renderExportButton = (title, onClickFunc, exportType) => {
        const exportUsed = this.props.exports.exportUsed.includes(exportType);
        return (
            <a id={`rc-subjects-export-button-${exportType}`} className={classnames("rc-button-frame rc-button-text", { 'is-disabled': exportUsed })} style={{ textAlign: 'center' }} onClick={() => exportUsed ? undefined : onClickFunc()}>
                <span style={{ top: '0px', transform: 'none' }}>{title}</span>
            </a>
        );
    }

    renderSlHeader = (data) => {
        if (data === null || data === undefined) { return null; }

        const maxLevel = data.maxLevel;

        return (<>
            <tr>
                <th className='info' colSpan={maxLevel + 1} style={{ border: 'none', paddingBottom: '0px' }} ><Translate id='Charts.SubjectListName' /></th>
                <th className='info' rowSpan={2} valign='middle'><Translate id='Charts.SubjectListIC' /></th>
                <th className='info' rowSpan={2} valign='middle'><Translate id='Charts.CompanyWarnings' /></th>
                <th className='info' rowSpan={2} valign='middle'><Translate id='Charts.ExportRelation' /></th>
                <th className='info' rowSpan={2} valign='middle'><Translate id='Charts.ExportShare' /></th>
                <th className='info' rowSpan={2} valign='middle'><Translate id='Charts.From' /></th>
                <th className='info' rowSpan={2} valign='middle'><Translate id='Charts.To' /></th>
                <th className='info' rowSpan={2} valign='middle'><Translate id='Charts.RelationDirectionStrongness' /></th>
                <th className='info' rowSpan={2} valign='middle'><Translate id='Charts.SubjectListAddress' /></th>
            </tr>
            <tr>
                <th className='info' width='60px' valign='middle'><Translate id='Charts.Level' /></th>
                {maxLevel > 0 && Array.from(Array(maxLevel)).map((e, i) => <th key={i} className='info' width={(i + 1 === maxLevel) ? 'auto' : '30px'}>{i + 1}</th>)}
            </tr>
        </>);
    }

    renderSlData = (nodes, maxLevel) => {
        if (nodes === null || nodes === undefined) { return null; }

        return nodes.sort(function (a, b) { return a.NameNormalized < b.NameNormalized ? -1 : 1 }).map(node => {
            if (node.EntityType === 'MergedRoot') { return null; }
            const rowSpan = node.Relations.length > 1 ? node.Relations.length + 1 : 1;
            const rowStyle = (node.Relations.length > 0 && node.Relations.filter(function (el) { return el.IsHistorical; }).length == node.Relations.length) ? { fontStyle: 'italic', color: '#949494', verticalAlign: 'middle' } : { verticalAlign: 'middle' };

            if (node.Relations === null || node.Relations.length === 0) {
                return this._noRelationRow(node, rowSpan, rowStyle, maxLevel);
            } else if (node.Relations.length === 1) {
                return this._oneRelationRow(node, rowSpan, rowStyle, maxLevel);
            } else {
                return this._manyRelationRow(node, rowSpan, rowStyle, maxLevel);
            }
        });
    }

    _noRelationRow = (node, rowSpan, rowStyle, maxLevel) => {
        return <React.Fragment key={node.EntityID}>
            <tr eid={node.EntityID} onClick={(e) => this.props.selectEntity(node.EntityID, e)}>
                {this._baseRowData(node, rowSpan, rowStyle, maxLevel)}
                <td></td><td></td><td></td><td></td><td></td><td rowSpan={rowSpan} style={rowStyle}>{node.Address || ''}</td>
            </tr>
            {node.ChildrenNodes.length > 0 && node.IsExpanded && this.renderSlData(node.ChildrenNodes, maxLevel)}
        </React.Fragment>
    }

    _getRelationShortening = (shortening) => {
        if (shortening) return " (" + shortening + ")";
        return "";
    }

    _oneRelationRow = (node, rowSpan, rowStyle, maxLevel) => {
        return <React.Fragment key={node.EntityID}>
            <tr eid={node.EntityID} onClick={(e) => this.props.selectEntity(node.EntityID, e)} style={{ height: '2em' }}>
                {this._baseRowData(node, rowSpan, rowStyle, maxLevel)}
                {node.Relations[0].RelationType === "NRCU" ? <td style={node.Relations[0].IsHistorical ? { fontStyle: 'italic', color: '#949494' } : {}}>
                    {
                        node.Relations[0].Description + this._getRelationShortening(node.Relations[0].RelationShortening)}
                </td>
                    : (((node.Relations[0].RootGroupId === "NRBO" && node.Relations[0].SourceID === "22") || node.Relations[0].RelationType === 'NR0217') && !isNullOrUndefined(node.Relations[0].Function)) ? <td style={node.Relations[0].IsHistorical ? { fontStyle: 'italic', color: '#949494' } : {}}>{node.Relations[0].Description + ' - ' + node.Relations[0].Function}</td>
                        : <td style={node.Relations[0].IsHistorical ? { fontStyle: 'italic', color: '#949494' } : {}}>{node.Relations[0].Description}</td>
                }
                <td style={node.Relations[0].IsHistorical ? { fontStyle: 'italic', color: '#949494' } : {}}>{node.Relations[0].Share}</td>
                <td style={node.Relations[0].IsHistorical ? { fontStyle: 'italic', color: '#949494' } : {}}>{node.Relations[0].FromDateFormated}</td>
                <td style={node.Relations[0].IsHistorical ? { fontStyle: 'italic', color: '#949494' } : {}}>{node.Relations[0].ToDateFormated}</td>
                <td style={{ lineHeight: '16px', fontSize: '22px', textAlign: 'center' }}>
                    {node.Relations[0].Direction}
                    <span style={{ display: 'inline-block', paddingLeft: '5px' }} className={`link-guarantee link-guarantee-${node.Relations[0].LinkGuarantee}`}></span>
                </td>
                <td style={rowStyle}>{node.Address}</td>
            </tr>
            {node.ChildrenNodes.length > 0 && node.IsExpanded && this.renderSlData(node.ChildrenNodes, maxLevel)}
        </React.Fragment>
    }

    _manyRelationRow = (node, rowSpan, rowStyle, maxLevel) => {
        return <React.Fragment key={node.EntityID}>
            <tr key={node.EntityID} eid={node.EntityID} onClick={(e) => this.props.selectEntity(node.EntityID, e)}>
                {this._baseRowData(node, rowSpan, rowStyle, maxLevel)}
            </tr>
            {node.Relations.map((v, i) => <tr key={`${node.EntityID}_${i}`} eid={node.EntityID} onClick={(e) => this.props.selectEntity(node.EntityID, e)}>
                {v.RelationType === "NRCU" ? <td style={v.IsHistorical ? { fontStyle: 'italic', color: '#949494' } : {}}>{v.Description + this._getRelationShortening(v.RelationShortening)}</td>
                    : (((v.RootGroupId === "NRBO" && v.SourceID === "22") || v.RelationType === 'NR0217') && !isNullOrUndefined(v.Function)) ? <td style={v.IsHistorical ? { fontStyle: 'italic', color: '#949494' } : {}}>{v.Description + ' - ' + v.Function}</td>
                        : <td style={v.IsHistorical ? { fontStyle: 'italic', color: '#949494' } : {}}>{v.Description}</td>}
                <td style={v.IsHistorical ? { fontStyle: 'italic', color: '#949494' } : {}}>{v.Share}</td>
                <td style={v.IsHistorical ? { fontStyle: 'italic', color: '#949494' } : {}}>{v.FromDateFormated}</td>
                <td style={v.IsHistorical ? { fontStyle: 'italic', color: '#949494' } : {}}>{v.ToDateFormated}</td>
                <td style={{ lineHeight: '16px', fontSize: '22px', textAlign: 'center' }}>
                    {v.Direction}
                    <span style={{ display: 'inline-block', paddingLeft: '5px' }} className={`link-guarantee link-guarantee-${v.LinkGuarantee}`}></span>
                </td>
                {i === 0 && <td rowSpan={(rowSpan - 1) < 1 ? 1 : (rowSpan - 1)} style={rowStyle}>{node.Address}</td>}
            </tr>)}
            {node.ChildrenNodes.length > 0 && node.IsExpanded && this.renderSlData(node.ChildrenNodes, maxLevel)}
        </ React.Fragment>
    }

    _baseRowData = (node, rowSpan, rowStyle, maxLevel) => {
        return <>
            {node.Level !== 0 && <><td align='right' rowSpan={rowSpan} colSpan={node.Level} style={{ verticalAlign: 'middle' }}>
                <div style={{ display: 'inline-flex' }}>
                    {(node.ChildrenNodes.length > 0 && node.IsExpanded) && <i style={{ top: '-2px', position: 'relative', paddingRight: '5px' }}>∟</i>}
                    {!(node.ChildrenNodes.length > 0 && node.IsExpanded) && <i style={{ top: '0px', position: 'relative', paddingRight: '5px' }}>─</i>}
                    {this._renderIcon(node.EntityType)}
                </div>
            </td>
                <td rowSpan={rowSpan} colSpan={maxLevel - node.Level + 1} style={rowStyle}>{node.Name}</td>
            </>}
            {node.Level === 0 && <td rowSpan={rowSpan} colSpan={maxLevel - node.Level + 1} style={rowStyle}>
                <div style={{ display: 'inline-flex' }}>
                    {this._renderIcon(node.EntityType)}
                    {node.Name}
                </div>
            </td>}

            <td rowSpan={rowSpan} style={rowStyle}>
                {node.EntityType === 'FO' && node.ICORDateOfBirthFormated}
                {node.EntityType !== 'FO' && (node.ICORDateOfBirth || '')}
            </td>
            <td rowSpan={rowSpan} style={rowStyle}>{this._slRenderWarnings(node.Warnings).map((w, i) => <span className={`warn-item warn-status-${w.StatusID}`} key={i}>{w.WarningsCode}</span>)}</td>
        </>
    }

    _renderIcon = (type) => {
        const Icon = type === 'PO' ? PoIcon : type === 'FO' ? FoIcon : type === 'FOP' ? FpoIcon : type === 'AD' ? AddrIcon : null;
        return <div className='search-result-icon' style={{ paddingRight: type === 'FO' ? '0.2em' : null }}>
            {Icon && <Icon className='svg-standard-fill' />}
        </div>
    }

    _slRenderWarnings(warnings) {
        var result = [];
        var observed = [];

        warnings.forEach(function (x) {
            var key = x.WarningsCode + '|' + x.StatusID;
            if (!observed.includes(key)) {
                result.push(x);
                observed.push(key);
            }
        });

        return result;
    }
}

export default withRouter(withLocalize(connect(
    state => state.charts,
    dispatch => bindActionCreators(chartActions, dispatch)
)(ChartSubjects)));
